<template>
  <div class="project">
    <div class="d-flex align-items-center">
      <project-icon :color="project.color" />
      <div class="bold pl-2 text-normal">{{ project.title }}</div>
    </div>
    <div class="sections pl-3">
      <div class="pt-2 ml-2 text-small" v-if="sectionsToShow.length === 0">
        No sections available
      </div>
      <move-initiative-section-row
        v-for="section in sectionsToShow"
        :key="section.id"
        :section="section"
        :project="project"
        @move="$emit('move', $event)"
        v-else
      />
    </div>
  </div>
</template>

<script>
import MoveInitiativeSectionRow from '@/components/initiative/MoveInitiativeSectionRow.vue'
import ProjectIcon from '@/components/project/ProjectIcon.vue'

/**
 * This provides lists down a project and sections inside it. For each section, there is a CTA for "Move here".
 * This allows movement of initiative from one project to another.
 */
export default {
  name: 'MoveInitiativeProjectRow',
  components: { MoveInitiativeSectionRow, ProjectIcon },
  props: ['project'],
  data() {
    return {}
  },
  computed: {
    sectionsToShow() {
      return this.project.sections
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/styles/_styleConfigurations.scss';

.project {
  padding: 18px 8px 0 0;
}
</style>
